import { Messages } from '../../../../codegen/Localize';
import { ServerSettingsUnauthenticated } from '../../../../settings/services/ServerSettingsUnauthenticated';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IServerUserInfo } from '../../../../ts/models/IServerUserInfo';
import { serverUserResetLoginRateLimiting } from '../../../actions/spaces/ServerUserMenuActions';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isSingleSelectServerUserGuest } from './IEntityActionHelpers';

export const ServerUserResetLoginRateLimitingAction: IEntityAction<IServerUserInfo, {}> = {
  name: EntityActionNames.ServerUserResetLoginRateLimiting,
  translateName: Messages.resetLoginRateLimiting_action,
  isVisible: (_targetItems: IServerUserInfo[], _state: AppState) => {
    return FeatureFlags.localAuthLoginRateLimitingEnabled && ServerSettingsUnauthenticated.isServerDomainFamilyLocal();
  },
  isClickable: (_availableActions: {}, targetItems: IServerUserInfo[], _state: AppState) => {
    return targetItems.length > 0 && !isSingleSelectServerUserGuest(targetItems);
  },
  createReduxAction: (targetItems: IServerUserInfo[]) => serverUserResetLoginRateLimiting(targetItems)
};
